import { Theme } from '@mui/material/styles';
import { createStyles } from '@mui/styles'

const styles = (theme: Theme) => createStyles({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    fontFamily: 'Roboto',
    backgroundColor: theme.palette.background.paper,
  },
});

export default styles;
